module.exports = __webpack_public_path__ + "media/images/review/ico-heart-s-1adae1a5a2f3a4111ddf6f2a596d15ce.svg";